import { Service } from "typedi";
import { AgentRPCCommand } from "../../../../shared/RPC/AgentRPCCommand";
import { AgentRPCCommands } from "../../../../shared/RPC/AgentRPCCommands";

const GATHER_TIMEOUT_MS = 2000;
const IPV4_RE = /(\d{1,3}\.){3}\d{1,3}/;
const IPV6_RE = /([a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|([a-fA-F0-9]{1,4}:){1,7}:|::([a-fA-F0-9]{1,4}:){0,6}[a-fA-F0-9]{1,4}/;

/**
 * WebRTC-based IP enumeration — same approach as the chrome agent's offscreen
 * implementation, but running in the iframe context where `RTCPeerConnection`
 * is available directly.
 */
@Service()
export class GetDeviceIpAddresses implements AgentRPCCommand<"get.device.ip.addresses"> {
    constructor(agentRPCCommands: AgentRPCCommands) {
        agentRPCCommands.register("get.device.ip.addresses", this);
    }

    async run(): Promise<string[]> {
        const pc = new RTCPeerConnection({ iceServers: [{ urls: "stun:stun.l.google.com:19302" }] });
        const ips = new Set<string>();

        return new Promise<string[]>((resolve) => {
            const finish = () => {
                pc.close();
                resolve([...ips]);
            };

            const timer = setTimeout(finish, GATHER_TIMEOUT_MS);

            pc.onicecandidate = (event) => {
                if (!event.candidate) {
                    clearTimeout(timer);
                    finish();
                    return;
                }
                const match = event.candidate.candidate.match(IPV4_RE) || event.candidate.candidate.match(IPV6_RE);
                if (match) ips.add(match[0]);
            };

            pc.createDataChannel("zaindari-ip-probe");
            pc.createOffer()
                .then((offer) => pc.setLocalDescription(offer))
                .catch(() => {
                    clearTimeout(timer);
                    finish();
                });
        });
    }
}
